/** Cartão de "carregando" das telas que dependem do serviço de monitoramento. */
export function LoadingCard({ message }: { message: string }) {
  return (
    <div className="border-line-200 text-ink-600 rounded-2xl border bg-white p-7 text-center text-[13.5px]">
      {message}
    </div>
  );
}

interface ErrorCardProps {
  title: string;
  detail: string | null;
  onRetry: () => void;
}

/** Cartão de falha no carregamento, com o botão de tentar de novo. */
export function ErrorCard({ title, detail, onRetry }: ErrorCardProps) {
  return (
    <div className="border-danger-200 bg-danger-100 text-danger-600 rounded-2xl border p-5 text-[13.5px]">
      <b>{title}</b>
      {detail ? <div className="mt-1 font-semibold">{detail}</div> : null}
      <button
        type="button"
        onClick={onRetry}
        className="border-danger-200 mt-3 rounded-[10px] border bg-white px-4 py-2 text-[12.5px] font-extrabold"
      >
        Tentar de novo
      </button>
    </div>
  );
}
